import React, { use, useEffect, useRef, useState } from 'react'
import Title from '../../components/common/Title'
import { Topbar } from '../../components/include/Topbar'
import HiOutlineDotsVertical from "../../assets/Icons/HiOutlineDotsVertical.svg";
import { useNavigate } from 'react-router-dom';
import DeleteModal from '../../components/common/DeleteModal';
import { Postdata } from '../../helpers/api.service';
import HttpService from '../../helpers/httpServices';
import { message } from '../../redux/actions/toastActions';
import { useDispatch, useSelector } from 'react-redux';
import dayjs from 'dayjs';
import Loader from '../../components/common/Loader';
import { isPermission, isRole } from '../../redux/selectors/authSelector';
import Error403Page from '../ErrorPage';

const NewsManagement_main = () => {
    const [modalOpenDelete, setmodalOpenDelete] = useState(false);
    const [selectedId, setSelectedId] = useState(null);
    const [openMenuIndex, setOpenMenuIndex] = useState(null);
    const [data, setData] = useState([]);
    const navigate = useNavigate();
    const menuRefs = useRef([]);
    const dispatch = useDispatch();
    const [refresh, setRefresh] = useState(false);
    const [loader, setLoader] = useState(false);
    const [modalOpenDeleteSuccess, setModalOpenDeleteSuccess] = useState(false);
    const permissions = useSelector(isPermission);
    const role = useSelector(isRole)
    console.log("permissions", permissions)
    const isAccessible = role == "schooladmin" || permissions && permissions?.includes('view_News_Management') || false;
    const addPermission = role == "schooladmin" || permissions && permissions?.includes('edit_News_Management') || false;
    const deletePermission = role == "schooladmin" || permissions && permissions?.includes('delete_News_Management') || false;


    const toggleMenu = (index) => {
        setOpenMenuIndex(openMenuIndex === index ? null : index);
    };

    const handleDelete = (id) => {
        setLoader(true)
        Postdata(HttpService.news_delete, { id: id }).then((res) => {
            if (res.status === 200) {
                setRefresh(!refresh);
            }
            else {
                dispatch(message(res.message));
            }
            setLoader(false)
        });
        setOpenMenuIndex(null);
    }

    const fetchData = () => {
        setLoader(true);
        Postdata(HttpService.news_list).then((res) => {
            if (res.status === 200) {
                setData(res.data);
            }else{

                dispatch(message(res.message));
            }
            setLoader(false)
        });
    }
    useEffect(() => {
        fetchData();
    }, [refresh])


    // Close menu on outside click
    useEffect(() => {
        const handleClickOutside = (event) => {
            let clickedInside = false;
            menuRefs.current.forEach(ref => {
                if (ref && ref.contains(event.target)) {
                    clickedInside = true;
                }
            });
            if (!clickedInside) {
                setOpenMenuIndex(null);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    if (!isAccessible) {
        return (
            <>
                <Error403Page />
            </>
        );
    }

    if (loader) {
        return <Loader isClass="loader_fullscreen" />
    }

    return (
        <div>
            <Title name="News" />
            <Topbar title="News" btn={addPermission || false} btnName="+Add" btnLink="/news-management/add" />
            <div className='p-6 space-y-6 pr-0'>
                <div className='grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3'>

                    {data.length > 0 && data.map((item, index) =>
                    (
                        <div className='bg-white rounded-lg ' key={index}>
                            <img className='w-full h-60 object-cover  mb-2' onClick={() => navigate(`/news-management/view/${item._id}`)} src={item.image} />
                            <div className=" relative flex justify-between text-gray-800   mx-auto">
                                <div>
                                    <h3 className="text-sm font-semibold pt-[10px] pl-[10px] ml-2">
                                        {item.title}
                                    </h3>
                                    <h3 className="text-sm text-gray-400 font-normal px-[10px] ml-2">
                                        {dayjs(item.createdAt).format("DD MMM YYYY")}
                                    </h3>

                                </div>
                                <div className='bg-white '>
                                    {(addPermission || deletePermission) && <div className="absolute top-3 right-3">
                                        <button onClick={() => toggleMenu(index)}>
                                            <img
                                                src={HiOutlineDotsVertical}
                                                className="text-black-500 hover:text-black"
                                            />
                                        </button>

                                        {openMenuIndex == index && (
                                            <div ref={(el) => (menuRefs.current[index] = el)} className="absolute right-5 bottom-0 w-20 bg-white shadow-md border rounded-xl z-10">
                                                {addPermission && <button
                                                    className="block w-full text-left px-3 rounded-t-xl py-2 text-sm hover:bg-gray-100"
                                                    onClick={() => navigate(`/news-management/edit/${item._id}`, { state: { type: "edit" } })}
                                                >
                                                    Edit
                                                </button>}
                                                {deletePermission && <button
                                                    onClick={() => {
                                                        setSelectedId(item._id);
                                                        setmodalOpenDelete(true);
                                                    }}
                                                    className="block w-full text-left px-3 rounded-b-xl py-2 text-sm hover:bg-gray-100"
                                                >
                                                    Delete
                                                </button>}
                                            </div>
                                        )}
                                    </div>}

                                </div>
                            </div>
                        </div>
                    )
                    )

                    }
                   

                    <DeleteModal
                        title="Delete News"
                        message="Are you sure you want to delete News?
It will erase all the data permanently."
                        modalOpenDelete={modalOpenDelete}
                        setmodalOpenDelete={setmodalOpenDelete}
                        handleDelete={handleDelete} // Don't call it here
                        selectedId={selectedId}
                        setSelectedId={setSelectedId}
                        modalOpenDeleteSuccess={modalOpenDeleteSuccess}
                        setModalOpenDeleteSuccess={setModalOpenDeleteSuccess}
                        module={"News Management"}
                        redirectPage={"News Management"}
                        redirectUrl={'/news-management'}
                    />
                </div>
                 {
                        data.length === 0 && <div className="h-[50vh] flex items-center justify-center w-full">
                            <h1 className="text-center text-gray-400">No Data Found</h1>
                        </div>
                    }
            </div>
        </div>
    )
}

export default NewsManagement_main